const AO = {
  ibanLength: 25,
};
export { AO };
